// extracted by mini-css-extract-plugin
export var chatHtmlText = "_q0-2";
export var chatLink = "_q0-0";
export var chatText = "_q0-1";